import type { UpdateableLineItem } from '../../line-items'
import { calculateMaterial } from '../../area-substrates/calculate-material'
import convertToUpdateableProductOption from '../util/convertToUpdateableProductOption/convertToUpdateableProductOption'
import type { BulkOperationProduct } from '..'

export function updateLineItemProduct(
  action: { oldProduct: string; newProduct: BulkOperationProduct },
  lineItem: UpdateableLineItem
): UpdateableLineItem {
  // Find all occurances of oldProduct on lineItem.materials, update them each to newProduct, copying over
  // relevant details we want to keep.
  let updatedLineItem = {
    ...lineItem
  }

  const updatedMaterials = lineItem.materials
  if (action.oldProduct === 'ADD_NEW_PRODUCT') {
    // If material addition, handle here

    // Turns the ProductOption into an UpdateableProduct type
    const updateableMaterial = convertToUpdateableProductOption(action.newProduct)

    const calculatedProduct = calculateMaterial(updateableMaterial)
    updatedMaterials.push(calculatedProduct)
  } else if (action.newProduct.label === 'REMOVE_PRODUCT') {
    //, If material removal, handle here
    lineItem.materials.forEach((material, i) => {
      if (material.label === action.oldProduct) {
        updatedMaterials.splice(i, 1)
      }
    })
  } else {
    // Filter through materials and replace old with new if standard swap

    // Handle replace empty material
    if (lineItem.materials.length === 0) {
      // const price = action.newProduct.price ? action.newProduct.price : 0
      const updateableMaterial = convertToUpdateableProductOption(action.newProduct)

      const calculatedMaterial = calculateMaterial(updateableMaterial)
      // replace this index in updatedMaterials with our newMaterial to replace the existing material
      updatedMaterials.push(calculatedMaterial)
    } else {
      // Handle replace existing material
      lineItem.materials.forEach((material, i) => {
        // const price = action.newProduct.price ? action.newProduct.price : 0
        if (material.label === action.oldProduct) {
          // old found, replace with new
          const updateableMaterial = convertToUpdateableProductOption(action.newProduct)

          const calculatedMaterial = calculateMaterial(updateableMaterial)
          // replace this index in updatedMaterials with our newMaterial to replace the existing material
          updatedMaterials[i] = calculatedMaterial
        }
      })
    }
  }

  // replace with our updatedMaterials and return
  updatedLineItem = {
    ...updatedLineItem,
    materials: updatedMaterials
  }

  return updatedLineItem
}
